import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { ActionTypes } from '../context/AppContext';
import { useNeo4j } from '../hooks/useNeo4j';

function ConnectionScreen() {
  const { dispatch } = useApp();
  const { connectToDatabase, fetchUserProfiles, isConnecting } = useNeo4j();
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [formData, setFormData] = useState({
    uri: 'neo4j+s://27f9cb4b.databases.neo4j.io',
    user: '27f9cb4b',
    password: 'cPlhd6ffObK2OT6JOrBDrcvT-4_3-SNTCXbPKKGjD30'
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setConnectionStatus(
      <div className="flex items-center justify-center gap-2 text-yellow-400">
        <div className="spinner w-5 h-5"></div>
        Connecting...
      </div>
    );

    const result = await connectToDatabase(formData.uri, formData.user, formData.password);
    
    if (result.success) {
      try {
        await fetchUserProfiles();
        dispatch({ type: ActionTypes.SET_SCREEN, payload: 'dashboard' });
      } catch (error) {
        setConnectionStatus(
          <div className="text-red-400">Failed to fetch data: {error.message}</div>
        );
      }
    } else {
      setConnectionStatus(
        <div className="text-red-400">Connection Failed: {result.error}</div>
      );
    }
  };

  return (
    <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md mx-auto mt-20">
      <h1 className="text-2xl font-bold text-teal-400 text-center mb-2">Connect to Neo4j</h1>
      <p className="text-center text-gray-400 mb-6 text-sm">
        Enter your database credentials to manage your team.
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="uri" className="block mb-2 text-sm font-medium">
            Database URI
          </label>
          <input
            type="text"
            id="uri"
            name="uri"
            value={formData.uri}
            onChange={handleInputChange}
            className="bg-gray-700 border border-gray-600 rounded-lg w-full p-2.5"
            required
          />
        </div>
        
        <div>
          <label htmlFor="user" className="block mb-2 text-sm font-medium">
            Username
          </label>
          <input
            type="text"
            id="user"
            name="user"
            value={formData.user}
            onChange={handleInputChange}
            className="bg-gray-700 border border-gray-600 rounded-lg w-full p-2.5"
            required
          />
        </div>
        
        <div>
          <label htmlFor="password" className="block mb-2 text-sm font-medium">
            Password
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            className="bg-gray-700 border border-gray-600 rounded-lg w-full p-2.5"
            placeholder="••••••••"
            required
          />
        </div>
        
        <button
          type="submit"
          disabled={isConnecting}
          className="w-full text-white bg-teal-600 hover:bg-teal-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {isConnecting ? 'Connecting...' : 'Connect'}
        </button>
      </form>
      
      {connectionStatus && (
        <div className="mt-4 text-center">
          {connectionStatus}
        </div>
      )}
    </div>
  );
}

export default ConnectionScreen;
